module.exports = __webpack_public_path__ + "static/media/2.355b7481.JPG";